module.exports = __webpack_public_path__ + "assets/img/banner.7dec44f1.jpg";